import {Component, Inject, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatListModule} from "@angular/material/list";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {AdaService} from "../../services/ada/ada.service";
import {AtecoService} from "../../services/ateco/ateco.service";
import {IscoService} from "../../services/isco/isco.service";
import {IstatService} from "../../services/istat/istat.service";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AssociazioniDialog} from "../associazioni-dialog/associazioni-dialog.component";
import {concat} from "rxjs";
import {tap, toArray} from "rxjs/operators";
import {ClassificazioniDialog} from "../classificazioni-dialog/classificazioni-dialog.component";

@Component({
  selector: 'modifica-proposta-competenza-dialog',
  templateUrl: './modifica-proposta-competenza-dialog.component.html',
  styleUrls: ['./modifica-proposta-competenza-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatListModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule],
})
export class ModificaPropostaCompetenzaDialog implements OnInit {
  listaAda: any;
  listaAteco: any;
  listaIsco: any;
  listaIstat: any;
  listaCompetenze: any;
  listaAree: any;
  listaConoscenze: any;
  listaAbilita: any;
  pdfVisible: boolean;
  xlsVisible: boolean;
  hasPermission: boolean;
  sectionName: any;
  detailsData: any;
  savedEvent: any;
  boxSearchData: any;
  sottocategoriaCompDiBaseConfig : any;

  formValues: any = {
    id: null,
    descrizione: '',
    informazioniCompetenza: '',
    eqfCompetenza: null,
    idTCategoriaBase : null,
    tipoArea: null,
    digital: false,
    green: false
  };

  constructor(
    public dialogRef: MatDialogRef<ModificaPropostaCompetenzaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ada: AdaService,
    private ateco: AtecoService,
    private isco: IscoService,
    private istat: IstatService,
    private api: HttpService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.api.getTipologiaCategoriaBase()
    .subscribe((response) => {
            this.overrideSottoCategoriaConfigs(response)
    })

    this.formValues.idTCategoriaBase = this.data.competenza.idTCategoriaBase;

    this.pdfVisible = this.data.competenza.stato.id === 5 || this.data.competenza.stato.id === 7
      || this.data.competenza.stato.id === 4;

    this.xlsVisible = this.data.competenza.stato.id === 3 || this.data.competenza.stato.id === 4
      || this.data.competenza.stato.id === 5 || this.data.competenza.stato.id === 7
      || this.data.competenza.stato.id === 9 || this.data.competenza.stato.id === 10
      || this.data.competenza.stato.id === 11;

    this.formValues.id = this.data.competenza.id;
    this.formValues.descrizione = this.data.competenza.descrizione;
    this.formValues.informazioniCompetenza = this.data.competenza.informazioniCompetenza;
    this.formValues.eqfCompetenza = this.data.competenza.eqfCompetenza;
    this.formValues.digital = this.data.competenza.digital;
    this.formValues.green = this.data.competenza.green;

    this.ada.getCodiciAdaByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaAda = response.result;
      }
    });

    this.ateco.getCodiciAtecoByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaAteco = response.result;
      }
    });

    this.isco.getCodiciIscoByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaIsco = response.result;
      }
    });

    this.istat.getCodiciIstatByIdCompetenza(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaIstat = response.result;
      }
    });
   this.getAbilitaConoscenze();
   if (this.data.competenza.tipologia.id === 1) {
    this.getAree();
  }
}

  overrideSottoCategoriaConfigs(response : any){
    this.sottocategoriaCompDiBaseConfig = response.result;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  salvaCompetenza() {
    this.api.salvaModificaCompetenza(this.formValues).subscribe({
      next: (response: any) => {
        this.snackBar.open('Competenza aggiornata con successo', 'close', { panelClass: 'successSnack' });
      }
    });
  }

  openClassificazioniDialog(data: any) {
    data['permission'] = true;
    data['element'] = data;
    const dialogRef = this.dialog.open(ClassificazioniDialog, {
      data: data,
      height: '115%',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {


      if (result) {

      }
    });
  }

  openModificaConoscenzeDialog(data: any) {
    data['permission'] = true;
    data['element'] = data;
    const dialogRef = this.dialog.open(AssociazioniDialog, {
      data: data,
      height: '95%',
      width: '80%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {

     this.getAbilitaConoscenze()
    });
  }

  conoscenzeEvent(event: any) {
    concat(
      this.api.getConoscenzeByCompetenza(event.id),
      this.api.ricercaConoscenze({}, 0, 10)
    ).pipe(
      tap((response) => {

      }),
      toArray(),
      tap((response) => {

      })
    ).subscribe({
      next: (response: any) => {


        let conoscenzeProposta = response[0].result;
        let listaConoscenze = response[1].result.listaConoscenze;
        let filteredLista = listaConoscenze.filter(function (o1: { id: any; }) {
          return !conoscenzeProposta.some(function (o2: { id: any; }) {
            return o1.id === o2.id;          // assumes unique id
          });
        })


        this.openAssociaCompetenzeDialog('edit', conoscenzeProposta, filteredLista, event.id, response[1].result.count, event.descrizione, '', 'conoscenze');
      }
    });

  }

  // EVENTO CLICK ASSOCIA ABILITA
  abilitaEvent(event: any) {
    concat(
      this.api.getAbilitaByCompetenza(event.id),
      this.api.ricercaAbilita({}, 0, 10)
    ).pipe(
      tap((response) => {

      }),
      toArray(),
      tap((response) => {

      })
    ).subscribe({
      next: (response: any) => {


        let abilitaProposta = response[0].result;
        let listaAbilita = response[1].result.listaAbilita
        // filtro per non far apparire nella lista competenze le competenze già associate
        let filteredLista = listaAbilita.filter(function (o1: { id: any; }) {
          return !abilitaProposta.some(function (o2: { id: any; }) {
            return o1.id === o2.id;          // assumes unique id
          });
        })

        this.openAssociaCompetenzeDialog('edit', abilitaProposta, filteredLista, event.id, response[1].result.count, event.descrizione, '', 'abilita');
      }
    });

  }

  openAssociaCompetenzeDialog(type: string, competenze: any, lista: any, idProposta: any, count: any, area: string, profilo: string, tipoAssociazione: string): void {

    const dialogRef = this.dialog.open(AssociazioniDialog, {
      data: { associate: competenze, lista: lista, area: area, count: count, profilo: profilo, permission: true, tipo: tipoAssociazione, isAssemblea: this.sectionName },
      height: '95%',
      width: '80%'
    });
    dialogRef.componentInstance.onSaveClick.subscribe((result) => {
      let data = result.associate;
      let tipo = (this.sectionName == 'gestioneAssemblea') ? 'assemblea' : tipoAssociazione;

      switch (tipo) {
        case 'competenze': {
          this.api.associaCompetenze(data, idProposta).subscribe({
            next: (response: any) => {
              this.snackBar.open('Competenze associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
          break;
        }

        case 'assemblea': {
          if (tipoAssociazione == 'competenze') {
            this.api.associaCompetenzeAssemblea(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Competenze associate con successo', 'close', { panelClass: 'successSnack' });
              }
            })
          } else {
            this.api.associaProfiliAssemblea(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Profili associati con successo', 'close', { panelClass: 'successSnack' });
              }
            })
          }

          break;
        }

        case 'conoscenze': {
          this.api.associaConoscenza(data, idProposta).subscribe({
            next: (response: any) => {
              this.snackBar.open('Conoscenze associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
          break;
        }

        case 'abilita': {
          this.api.associaAbilita(data, idProposta).subscribe({
            next: (response: any) => {
              this.snackBar.open('Abilità associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
          break;
        }
      }
    })

    dialogRef.afterClosed().subscribe((result: any) => {


      if (result) {
        let data = result.associate;
        let tipo = (this.sectionName == 'gestioneAssemblea') ? 'assemblea' : tipoAssociazione;

        switch (tipo) {
          case 'competenze': {
            this.api.associaCompetenze(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Competenze associate con successo', 'close', { panelClass: 'successSnack' });
              }
            })
            break;
          }

          case 'assemblea': {
            if (tipoAssociazione == 'competenze') {
              this.api.associaCompetenzeAssemblea(data, idProposta).subscribe({
                next: (response: any) => {
                  this.snackBar.open('Competenze associate con successo', 'close', { panelClass: 'successSnack' });
                }
              })
            } else {
              this.api.associaProfiliAssemblea(data, idProposta).subscribe({
                next: (response: any) => {
                  this.snackBar.open('Profili associati con successo', 'close', { panelClass: 'successSnack' });
                }
              })
            }

            break;
          }

          case 'conoscenze': {
            this.api.associaConoscenza(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Conoscenze associate con successo', 'close', { panelClass: 'successSnack' });
              }
            })
            break;
          }

          case 'abilita': {
            this.api.associaAbilita(data, idProposta).subscribe({
              next: (response: any) => {
                this.snackBar.open('Abilità associate con successo', 'close', { panelClass: 'successSnack' });
              }
            })
            break;
          }
        }
      }
      this.getAbilitaConoscenze();
    });

  }

  getAbilitaConoscenze() {
    this.api.getCompetenzaDettaglio(this.data.competenza.id).subscribe({
      next: (response: any) => {
        this.listaConoscenze = response.result.listaConoscenze;
        this.listaAbilita = response.result.listaAbilita;
      }
    })
  }

  getAree() {
    this.api.getTAreaProfiloAttivo().subscribe({
      next: (response: any) => {
        response.result.sort((a: any, b: any) => {
          const numA = Number(a.descrizione.match(/\d+/)?.[0] || 0);
          const numB = Number(b.descrizione.match(/\d+/)?.[0] || 0);
          return numA - numB;
        }
      );
      this.listaAree = response.result;
      if (this.data.competenza.tipoArea) {
        this.formValues.tipoArea = this.listaAree.find((a: any) => a.id === this.data.competenza.tipoArea.id);
      }
    }
  })
}

  onDigitalToggleChange(){
    this.formValues.digital=!this.formValues.digital;
  }

  onGreenToggleChange(){
    this.formValues.green=!this.formValues.green;
  }
}

